import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CollageDesignerMainControlPanel from './CollageDesignerMainControlPanel';
import CollageDesignerSecondaryControlPanel from './CollageDesignerSecondaryControlPanel';
import DesignEditorControls from '../../../DesignEditor/components/DesignEditorControls';
import { CONTROL_SECTION } from '../../helpers';

const propTypes = {
  className: PropTypes.string,
  onCardSettingsUpdate: PropTypes.func.isRequired,
  onCardElementCreate: PropTypes.func.isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
  card: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  backgroundElement: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
};

const CollageDesignerControlPanel = ({
  className,
  onCardSettingsUpdate,
  onCardElementCreate,
  onElementConfigurationChange,
  backgroundElement,
  card,
}) => {
  const classes = classNames({
    [className]: !!className,
    'collage-designer-left-control-pane': true,
  });
  const [activeControlSection, setActiveControlSection] = useState(
    CONTROL_SECTION.LAYOUT,
  );

  return (
    <DesignEditorControls className={classes}>
      <CollageDesignerMainControlPanel
        onControlSelect={setActiveControlSection}
        activeControlSection={activeControlSection}
      />

      <CollageDesignerSecondaryControlPanel
        activeControlSection={activeControlSection}
        onCardSettingsUpdate={onCardSettingsUpdate}
        onCardElementCreate={onCardElementCreate}
        onElementConfigurationChange={onElementConfigurationChange}
        backgroundElement={backgroundElement}
        card={card}
      />
    </DesignEditorControls>
  );
};

CollageDesignerControlPanel.propTypes = propTypes;

export default CollageDesignerControlPanel;
